export const processMcqAnalysis = async (paperId: string, limit: number, source: string) => {
  try {
    console.log(paperId, limit, source)
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/mcq-analysis`, {
    // const response = await fetch(`http://localhost:3001/mcq-analysis`, {
      method: 'POST',
      body: JSON.stringify({ paperId, limit, source }),
      headers: { 'Content-Type': 'application/json', charset: 'utf-8' },
    })
    if (!response.ok) {
      const text = await response.text()
      console.error('Backend error:', text)
      return {status:false}
    }
    const data = await response.json()
    if (data?.status === true && data?.details) {
      const refactorMcqAnalysis = data?.details?.map((item: any) => {
        return {
          question_id: item?.question_id || '',
          option_A: item?.a || '',
          option_B: item?.b || '',
          option_C: item?.c || '',
          option_D: item?.d || '',
          option_E: item?.e || '',
          skipped: item?.skipped || '',
          right_answer_option: item?.right_answer_option || '',
          most_responded_option: item?.most_responded_option || '',
          right_answer_percentage: item?.right_answer_percentage || '',
          total_number_of_candidates: item?.total_candidates || '',
          mcq_analysis_status: item?.mcq_analysis || false,
          need_to_review: item?.need_to_review || '',
        }
      })
      return { status: true, details: refactorMcqAnalysis }
    } else {
      return { status: false }
    }
  } catch (err) {
    return { status: false, message:"Unable to finish the task please try again later..." }
  }
}
